<template>
  <div>
    <div class="flow-root mt-6">
      <ul
        role="list"
        class="-my-5 divide-y divide-gray-200"
      >
        <li
          v-for="user in users"
          :key="user.id"
          class="py-4"
        >
          <div class="flex items-center space-x-4">
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-left text-gray-900 capitalize">
                {{ user.attributes.username }}
              </p>
            </div>
            <div>
              <button
                class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                @click="$emit('transfer', user)"
              >
                Select
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { User } from '@letsdial/api/src/lib/types/User'
  import { defineComponent, PropType } from 'vue'
  const props = withDefaults(defineProps<{ users: User[] }>(), {})
  const emit = defineEmits<{ transfer: [user: User] }>()
</script>
